import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "../api";

const PAGES = {
  "/contact-us": "/contact",
  "/contact-sales": "/contact",
  "/get-started": "/pricing",
  "/become-a-partner": "/partners",
  "/privacy-policy": "/legal/privacy-policy",
  "/terms-of-service": "/legal/terms-of-service",
  "/connected-operation": "/features",
  "/connected-commute": "/solutions",
  "/fleet-management-software-demo-fleetroot": "/contact",
  "/fleetroot-delivery-management-software": "/features",
  "/fleetroot-delivery-logistics-software": "/features",
  "/fleetroot-efficient-delivery-tracking-software": "/features",
  "/thank-you": "/",
  "/sitemap": "/blog",
  "/activities": "/about",
  "/fleetroots-impact-on-optimising-on-demand-delivery-operations-for-medicina-group-of-pharmacies": "/case-studies/medicina-group-of-pharmacies",
  "/how-fleetroot-helped-a-leading-gift-marketplace-increase-their-sla-adherence-and-improve-service-times-and-customer-experience": "/case-studies/joi-gifts",
  "/sare3-transforming-last-mile-delivery-with-fleetroot-delivery-management": "/case-studies/sare3",
  "/revolutionizing-fb-delivery-up-star-restaurant-group-optimizes-operations-with-fleetroot": "/case-studies/upstar-restaurant",
};

export default function LegacyRedirect() {
  const { pathname, search } = useLocation();
  const path = pathname.replace(/\/+$/, "") || "/";
  const [target, setTarget] = useState(PAGES[path] || null);
  const slug = path.split("/").filter(Boolean).pop();

  useEffect(() => {
    if (PAGES[path] || path === "/" || !slug) return;
    api
      .get("/redirect-target", { params: { slug } })
      .then((r) => setTarget(r.data.to || "/blog"))
      .catch(() => setTarget("/blog"));
  }, [path, slug]);

  if (path === "/") return <Navigate to="/" replace />;
  if (!target) return <div className="min-h-[60vh]" data-testid="legacy-redirecting" />;
  return <Navigate to={`${target}${search}`} replace />;
}
